import { useContext } from 'react'
import { ReactReduxContext } from 'react-redux'
import { Settings } from 'lucide-react'
import { setBlockSheetOpen } from '@/features/editor/editorSlice'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/**
 * Телефон/планшет (уже `lg`): на месте «Копии» миниатюры — настройки экрана.
 * Выбирает экран и открывает шторку с его настройками. Копия на телефоне не нужна,
 * а до настроек экрана иначе не добраться.
 */
export const ThumbSettingsButton = ({ onSelect }: { onSelect: () => void }) => {
  const m = useMessages(messages)
  // Стор — через контекст, а не `useAppDispatch`: миниатюру рендерят и без
  // провайдера (превью, тесты ленты), а нужен он только этой кнопке и только по клику.
  const redux = useContext(ReactReduxContext)
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onSelect()
        redux?.store.dispatch(setBlockSheetOpen(true))
      }}
      title={m.openBlockPanel}
      aria-label={m.openBlockPanel}
      className="absolute bottom-1 right-1.5 z-10 rounded-full border border-foreground/30 bg-background/35 p-1 text-foreground shadow-md [@media(hover:hover)]:opacity-0 backdrop-blur-[3px] transition hover:bg-background/55 group-hover:opacity-100 focus-visible:opacity-100 lg:hidden"
    >
      <Settings className="h-3 w-3" />
    </button>
  )
}
